import { createStructuredSelector } from 'reselect'

import {
    ROUTE_ADMINISTRATION_GROUP,
    ROUTE_ADMINISTRATION_GROUP_SUCCESS,
    ROUTE_ADMINISTRATION_GROUP_ERROR,
    DOSAGE_FORM_GROUP,
    DOSAGE_FORM_GROUP_SUCCESS,
    DOSAGE_FORM_GROUP_ERROR,
    ROUTE_ADMINISTRATION,
    ROUTE_ADMINISTRATION_SUCCESS,
    ROUTE_ADMINISTRATION_ERROR,
    DOSAGE_FORM,
    DOSAGE_FORM_SUCCESS,
    DOSAGE_FORM_ERROR,
    DISPENSING_UNIT,
    DISPENSING_UNIT_SUCCESS,
    DISPENSING_UNIT_ERROR,
    UNSPSC,
    UNSPSC_SUCCESS,
    UNSPSC_ERROR,
    UNSPSC_FAMILY,
    UNSPSC_FAMILY_SUCCESS,
    UNSPSC_FAMILY_ERROR,
    UNSPSC_CLASS,
    UNSPSC_CLASS_SUCCESS,
    UNSPSC_CLASS_ERROR,
    ACTIVE_INGREDIENT_CODE20,
    ACTIVE_INGREDIENT_CODE20_SUCCESS,
    ACTIVE_INGREDIENT_CODE20_ERROR,
    DOSAGE_FORM_CODE20,
    DOSAGE_FORM_CODE20_SUCCESS,
    DOSAGE_FORM_CODE20_ERROR,
    MED_DESCRIPTION_CODE20,
    MED_DESCRIPTION_CODE20_SUCCESS,
    MED_DESCRIPTION_CODE20_ERROR,
    SOURCE_CODE20,
    SOURCE_CODE20_SUCCESS,
    SOURCE_CODE20_ERROR,
    PROJECT,
    PROJECT_SUCCESS,
    PROJECT_ERROR,
    ARTICLE_CODE22,
    ARTICLE_CODE22_SUCCESS,
    ARTICLE_CODE22_ERROR,
    BIDDER,
    BIDDER_SUCCESS,
    BIDDER_ERROR,
    PROCESS_CODE,
    PROCESS_CODE_SUCCESS,
    PROCESS_CODE_ERROR,
    COUNTRY_BID,
    COUNTRY_BID_SUCCESS,
    COUNTRY_BID_ERROR,
    MED_DESCRIPTION_CODE22,
    MED_DESCRIPTION_CODE22_SUCCESS,
    MED_DESCRIPTION_CODE22_ERROR,
    ARTICLE_TYPE,
    ARTICLE_TYPE_SUCCESS,
    ARTICLE_TYPE_ERROR,
    ARTICLE_GROUP,
    ARTICLE_GROUP_SUCCESS,
    ARTICLE_GROUP_ERROR,
    COUNTRY_SUPPLIER,
    COUNTRY_SUPPLIER_SUCCESS,
    COUNTRY_SUPPLIER_ERROR,
    SUPPLIER_TYPE,
    SUPPLIER_TYPE_SUCCESS,
    SUPPLIER_TYPE_ERROR,
    PUBLICATION_TYPE,
    PUBLICATION_TYPE_SUCCESS,
    PUBLICATION_TYPE_ERROR,
    PUBLICATION_FORMAT,
    PUBLICATION_FORMAT_SUCCESS,
    PUBLICATION_FORMAT_ERROR,
    PUBLICATION_STATUS,
    PUBLICATION_STATUS_SUCCESS,
    PUBLICATION_STATUS_ERROR,
    PUBLICATION_PROJECT,
    PUBLICATION_PROJECT_SUCCESS,
    PUBLICATION_PROJECT_ERROR,
    COUNTRY_OPENNING,
    COUNTRY_OPENNING_SUCCESS,
    COUNTRY_OPENNING_ERROR,
    PROCESS_CODE_BID,
    PROCESS_CODE_BID_SUCCESS,
    PROCESS_CODE_BID_ERROR,
    COUNTRY_SOURCE_CODE22,
    COUNTRY_SOURCE_CODE22_SUCCESS,
    COUNTRY_SOURCE_CODE22_ERROR,
    MED_DESCRIPTION_CODE22_ORP,
    MED_DESCRIPTION_CODE22_ORP_SUCCESS,
    MED_DESCRIPTION_CODE22_ORP_ERROR,
    SOURCE_CODE22,
    SOURCE_CODE22_SUCCESS,
    SOURCE_CODE22_ERROR,
    PROCCESS_YEAR,
    PROCCESS_YEAR_SUCCESS,
    PROCCESS_YEAR_ERROR,
    ANIO_PRICE_CODE22,
    ANIO_PRICE_CODE22_SUCCESS,
    ANIO_PRICE_CODE22_ERROR,
    PROCESS_CODE_BIDDER,
    PROCESS_CODE_BIDDER_SUCCESS,
    PROCESS_CODE_BIDDER_ERROR,
    PROCCESS_YEAR_BIDDER,
    PROCCESS_YEAR_BIDDER_SUCCESS,
    PROCCESS_YEAR_BIDDER_ERROR,
    LOTE_STATE,
    LOTE_STATE_SUCCESS,
    LOTE_STATE_ERROR,
    YEAR_DEMAND,
    YEAR_DEMAND_SUCCESS,
    YEAR_DEMAND_ERROR,
    YEAR_GOB360,
    YEAR_GOB360_SUCCESS,
    YEAR_GOB360_ERROR,
    INSTITUTION_GOB360,
    INSTITUTION_GOB360_SUCCESS,
    INSTITUTION_GOB360_ERROR,
    PROCESS_CODE_OPENING,
    PROCESS_CODE_OPENING_SUCCESS,
    PROCESS_CODE_OPENING_ERROR,
    UNIT_PRICE,
    UNIT_PRICE_SUCCESS,
    UNIT_PRICE_ERROR,
    UNIT_PRICE_TRANSACCIONES,
    UNIT_PRICE_TRANSACCIONES_SUCCESS,
    UNIT_PRICE_TRANSACCIONES_ERROR,
    LIST_ARTICLE_ORP_CODE22,
    LIST_ARTICLE_ORP_CODE22_SUCCESS,
    LIST_ARTICLE_ORP_CODE22_ERROR,
    LIST_ARTICLE_CODE_COUNTRY,
    LIST_ARTICLE_CODE_COUNTRY_SUCCESS,
    LIST_ARTICLE_CODE_COUNTRY_ERROR,
    LIST_ARTICLE_CODE_COUNTRY_BIDDER,
    LIST_ARTICLE_CODE_COUNTRY_BIDDER_SUCCESS,
    LIST_ARTICLE_CODE_COUNTRY_BIDDER_ERROR,
    COUNTRY_TAB_AWARD,
    COUNTRY_TAB_AWARD_SUCCESS,
    COUNTRY_TAB_AWARD_ERROR,
    PROCCESS_CODE_TAB_AWARD,
    PROCCESS_CODE_TAB_AWARD_SUCCESS,
    PROCCESS_CODE_TAB_AWARD_ERROR,
    YEAR_TAB_AWARD,
    YEAR_TAB_AWARD_SUCCESS,
    YEAR_TAB_AWARD_ERROR,
    PROCCESS_CODE_TAB_OPENNING,
    PROCCESS_CODE_TAB_OPENNING_SUCCESS,
    PROCCESS_CODE_TAB_OPENNING_ERROR,
    YEAR_TAB_OPENNING,
    YEAR_TAB_OPENNING_SUCCESS,
    YEAR_TAB_OPENNING_ERROR,
    COUNTRY_TAB_OPENNING,
    COUNTRY_TAB_OPENNING_SUCCESS,
    COUNTRY_TAB_OPENNING_ERROR,
    ARTICLE_CODE22_SUPPLIER,
    ARTICLE_CODE22_SUPPLIER_SUCCESS,
    ARTICLE_CODE22_SUPPLIER_ERROR,
    ARTICLE_CODE_COUNTRY_SUPPLIER,
    ARTICLE_CODE_COUNTRY_SUPPLIER_SUCCESS,
    ARTICLE_CODE_COUNTRY_SUPPLIER_ERROR,
    COUNTRY_SUPPLIER_INFO,
    COUNTRY_SUPPLIER_INFO_SUCCESS,
    COUNTRY_SUPPLIER_INFO_ERROR,
    SUPPLIER_INFO,
    SUPPLIER_INFO_SUCCESS,
    SUPPLIER_INFO_ERROR,
    MED_DESCRIPTION_RAZONABILIDAD,
    MED_DESCRIPTION_RAZONABILIDAD_SUCCESS,
    MED_DESCRIPTION_RAZONABILIDAD_ERROR,
    LIST_ARTICLE_RAZONABILIDAD,
    LIST_ARTICLE_RAZONABILIDAD_SUCCESS,
    LIST_ARTICLE_RAZONABILIDAD_ERROR,
    COUNTRY_AWARD,
    COUNTRY_AWARD_SUCCESS,
    COUNTRY_AWARD_ERROR,
    ROLE,
    ROLE_SUCCESS,
    ROLE_ERROR,
    ROLE_ORP, 
    ROLE_ORP_SUCCESS,
    ROLE_ORP_ERROR
} from '../actions';

export const NAME = 'catalogList';


export const RouteAdministrationGroup = (filters) => ({
    type: ROUTE_ADMINISTRATION_GROUP,
    payload: { filters: filters }
});

export const RouteAdministrationGroupSuccess = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_SUCCESS,
  payload: data
});

export const RouteAdministrationGroupError = (error) => ({
    type: ROUTE_ADMINISTRATION_GROUP_ERROR,
  payload: error
});

export const DosageFormGroup = (filters) => ({
    type: DOSAGE_FORM_GROUP,
    payload: { filters: filters }
});

export const DosageFormGroupSuccess = (data) => ({
    type: DOSAGE_FORM_GROUP_SUCCESS,
    payload: data
});

export const DosageFormGroupError = (error) => ({
    type: DOSAGE_FORM_GROUP_ERROR,
    payload: error
});


export const RouteAdministration = (filters) => ({
    type: ROUTE_ADMINISTRATION,
    payload: { filters: filters }
});

export const RouteAdministrationSuccess = (data) => ({
    type: ROUTE_ADMINISTRATION_SUCCESS,
    payload: data
});

export const RouteAdministrationError = (error) => ({
    type: ROUTE_ADMINISTRATION_ERROR,
    payload: error
});

export const DosageForm = (filters) => ({
    type: DOSAGE_FORM,
    payload: { filters: filters }
});

export const DosageFormSuccess = (data) => ({
    type: DOSAGE_FORM_SUCCESS,
    payload: data
});

export const DosageFormError = (error) => ({
    type: DOSAGE_FORM_ERROR,
    payload: error
});

export const DispensingUnit = (filters) => ({
    type: DISPENSING_UNIT,
    payload: { filters: filters }
});

export const DispensingUnitSuccess = (data) => ({
    type: DISPENSING_UNIT_SUCCESS,
    payload: data
});

export const DispensingUnitError = (error) => ({
    type: DISPENSING_UNIT_ERROR,
    payload: error
});

export const Unspsc = (filters) => ({
    type: UNSPSC,
    payload: { filters: filters }
});

export const UnspscSuccess = (data) => ({
    type: UNSPSC_SUCCESS,
    payload: data
});

export const UnspscError = (error) => ({
    type: UNSPSC_ERROR,
    payload: error
});

export const UnspscFamily = (filters) => ({
    type: UNSPSC_FAMILY,
    payload: { filters: filters }
});

export const UnspscFamilySuccess = (data) => ({
    type: UNSPSC_FAMILY_SUCCESS,
    payload: data
});

export const UnspscFamilyError = (error) => ({
    type: UNSPSC_FAMILY_ERROR,
    payload: error
});

export const UnspscClass = (filters) => ({
    type: UNSPSC_CLASS,
    payload: { filters: filters }
});

export const UnspscClassSuccess = (data) => ({
    type: UNSPSC_CLASS_SUCCESS,
    payload: data
});

export const UnspscClassError = (error) => ({
    type: UNSPSC_CLASS_ERROR,
    payload: error
});

export const ActiveIngredientCode20 = (filters) => ({
    type: ACTIVE_INGREDIENT_CODE20,
    payload: { filters: filters }
});

export const ActiveIngredientCode20Success = (data) => ({
    type: ACTIVE_INGREDIENT_CODE20_SUCCESS,
    payload: data
});

export const ActiveIngredientCode20Error = (error) => ({
    type: ACTIVE_INGREDIENT_CODE20_ERROR,
    payload: error
});

export const DosageFormCode20 = (filters) => ({
    type: DOSAGE_FORM_CODE20,
    payload: { filters: filters }
});

export const DosageFormCode20Success = (data) => ({
    type: DOSAGE_FORM_CODE20_SUCCESS,
    payload: data
});

export const DosageFormCode20Error = (error) => ({
    type: DOSAGE_FORM_CODE20_ERROR,
    payload: error
});

export const MedDescriptionCode20 = (filters) => ({
    type: MED_DESCRIPTION_CODE20,
    payload: { filters: filters }
});

export const MedDescriptionCode20Success = (data) => ({
    type: MED_DESCRIPTION_CODE20_SUCCESS,
    payload: data
});

export const MedDescriptionCode20Error = (error) => ({
    type: MED_DESCRIPTION_CODE20_ERROR,
    payload: error
});

export const SourceCode20 = (filters) => ({
    type: SOURCE_CODE20,
    payload: { filters: filters }
});

export const SourceCode20Success = (data) => ({
    type: SOURCE_CODE20_SUCCESS,
    payload: data
});

export const SourceCode20Error = (error) => ({
    type: SOURCE_CODE20_ERROR,
    payload: error
});

export const Project = (filters) => ({
    type: PROJECT,
    payload: { filters: filters }
});

export const ProjectSuccess = (data) => ({
    type: PROJECT_SUCCESS,
    payload: data
});

export const ProjectError = (error) => ({
    type: PROJECT_ERROR,
    payload: error
});

export const ArticleCode22 = (filters) => ({
    type: ARTICLE_CODE22,
    payload: { filters: filters }
});

export const ArticleCode22Success = (data) => ({
    type: ARTICLE_CODE22_SUCCESS,
    payload: data
});

export const ArticleCode22Error = (error) => ({
    type: ARTICLE_CODE22_ERROR,
    payload: error
});

export const Bidder = (filters) => ({
    type: BIDDER,
    payload: { filters: filters }
});

export const BidderSuccess = (data) => ({
    type: BIDDER_SUCCESS,
    payload: data
});

export const BidderError = (error) => ({
    type: BIDDER_ERROR,
    payload: error
});

export const CountryBid = (filters) => ({
    type: COUNTRY_BID,
    payload: { filters: filters }
});

export const CountryBidSuccess = (data) => ({
    type: COUNTRY_BID_SUCCESS,
    payload: data
});

export const CountryBidError = (error) => ({
    type: COUNTRY_BID_ERROR,
    payload: error
});

export const MedDescriptionCode22 = (filters) => ({
    type: MED_DESCRIPTION_CODE22,
    payload: { filters: filters }
});

export const MedDescriptionCode22Success = (data) => ({
    type: MED_DESCRIPTION_CODE22_SUCCESS,
    payload: data
});

export const MedDescriptionCode22Error = (error) => ({
    type: MED_DESCRIPTION_CODE22_ERROR,
    payload: error
});

export const ArticleType = (filters) => ({
    type: ARTICLE_TYPE,
    payload: { filters: filters }
});

export const ArticleTypeSuccess = (data) => ({
    type: ARTICLE_TYPE_SUCCESS,
    payload: data
});

export const ArticleTypeError = (error) => ({
    type: ARTICLE_TYPE_ERROR,
    payload: error
});

export const ArticleGroup = (filters) => ({
    type: ARTICLE_GROUP,
    payload: { filters: filters }
});

export const ArticleGroupSuccess = (data) => ({
    type: ARTICLE_GROUP_SUCCESS,
    payload: data
});

export const ArticleGroupError = (error) => ({
    type: ARTICLE_GROUP_ERROR,
    payload: error
});

export const CountrySupplier = (filters) => ({
    type: COUNTRY_SUPPLIER,
    payload: { filters: filters }
});

export const CountrySupplierSuccess = (data) => ({
    type: COUNTRY_SUPPLIER_SUCCESS,
    payload: data
});

export const CountrySupplierError = (error) => ({
    type: COUNTRY_SUPPLIER_ERROR,
    payload: error
});

export const SupplierType = (filters) => ({
    type: SUPPLIER_TYPE,
    payload: { filters: filters }
});

export const SupplierTypeSuccess = (data) => ({
    type: SUPPLIER_TYPE_SUCCESS,
    payload: data
});

export const SupplierTypeError = (error) => ({
    type: SUPPLIER_TYPE_ERROR,
    payload: error
});

export const PublicationType = (filters) => ({
    type: PUBLICATION_TYPE,
    payload: { filters: filters }
});

export const PublicationTypeSuccess = (data) => ({
    type: PUBLICATION_TYPE_SUCCESS,
    payload: data
});

export const PublicationTypeError = (error) => ({
    type: PUBLICATION_TYPE_ERROR,
    payload: error
});

export const PublicationFormat = (filters) => ({
    type: PUBLICATION_FORMAT,
    payload: { filters: filters }
});

export const PublicationFormatSuccess = (data) => ({
    type: PUBLICATION_FORMAT_SUCCESS,
    payload: data
});

export const PublicationFormatError = (error) => ({
    type: PUBLICATION_FORMAT_ERROR,
    payload: error
});

export const PublicationStatus = (filters) => ({
    type: PUBLICATION_STATUS,
    payload: { filters: filters }
});

export const PublicationStatusSuccess = (data) => ({
    type: PUBLICATION_STATUS_SUCCESS,
    payload: data
});

export const PublicationStatusError = (error) => ({
    type: PUBLICATION_STATUS_ERROR,
    payload: error
});

export const PublicationProject = (filters) => ({
    type: PUBLICATION_PROJECT,
    payload: { filters: filters }
});

export const PublicationProjectSuccess = (data) => ({
    type: PUBLICATION_PROJECT_SUCCESS,
    payload: data
});

export const PublicationProjectError = (error) => ({
    type: PUBLICATION_PROJECT_ERROR,
    payload: error
});

export const CountryOpenning = (filters, stateFilter) => ({
    type: COUNTRY_OPENNING,
    payload: { filters: filters, filtersState: stateFilter  }
});

export const CountryOpenningSuccess = (data) => ({
    type: COUNTRY_OPENNING_SUCCESS,
    payload: data
});

export const CountryOpenningError = (error) => ({
    type: COUNTRY_OPENNING_ERROR,
    payload: error
});

export const ProcessCode = (filters, stateFilter) => ({
    type: PROCESS_CODE,
    payload: { filters: filters, filtersState: stateFilter }
});

export const ProcessCodeSuccess = (data) => ({
    type: PROCESS_CODE_SUCCESS,
    payload: data
});

export const ProcessCodeError = (error) => ({
    type: PROCESS_CODE_ERROR,
    payload: error
});

export const ProcessCodeBid = (filters) => ({
    type: PROCESS_CODE_BID,
    payload: { filters: filters }
});

export const ProcessCodeBidSuccess = (data) => ({
    type: PROCESS_CODE_BID_SUCCESS,
    payload: data
});

export const ProcessCodeBidError = (error) => ({
    type: PROCESS_CODE_BID_ERROR,
    payload: error
});

export const CountrySourceCode22 = (filters, stateFilter) => ({
    type: COUNTRY_SOURCE_CODE22,
    payload: { filters: filters, filtersState: stateFilter }
});

export const CountrySourceCode22Success = (data) => ({
    type: COUNTRY_SOURCE_CODE22_SUCCESS,
    payload: data
});

export const CountrySourceCode22Error = (error) => ({
    type: COUNTRY_SOURCE_CODE22_ERROR,
    payload: error
});

export const MedDescriptionCode22Orp = (filters) => ({
    type: MED_DESCRIPTION_CODE22_ORP,
    payload: { filters: filters }
});

export const MedDescriptionCode22OrpSuccess = (data) => ({
    type: MED_DESCRIPTION_CODE22_ORP_SUCCESS,
    payload: data
});

export const MedDescriptionCode22OrpError = (error) => ({
    type: MED_DESCRIPTION_CODE22_ORP_ERROR,
    payload: error
});

export const SourceCode22 = (filters) => ({
    type: SOURCE_CODE22,
    payload: { filters: filters }
});

export const SourceCode22Success = (data) => ({
    type: SOURCE_CODE22_SUCCESS,
    payload: data
});

export const SourceCode22Error = (error) => ({
    type: SOURCE_CODE22_ERROR,
    payload: error
});


export const ProccessYear = (filters) => ({
    type: PROCCESS_YEAR,
    payload: { filters: filters }
});

export const ProccessYearSuccess = (data) => ({
    type: PROCCESS_YEAR_SUCCESS,
    payload: data
});

export const ProccessYearError = (error) => ({
    type: PROCCESS_YEAR_ERROR,
    payload: error
});

export const AnioPriceCode22 = (filters) => ({
    type: ANIO_PRICE_CODE22,
    payload: { filters: filters }
});

export const AnioPriceCode22Success = (data) => ({
    type: ANIO_PRICE_CODE22_SUCCESS,
    payload: data
});

export const AnioPriceCode22Error = (error) => ({
    type: ANIO_PRICE_CODE22_ERROR,
    payload: error
});

export const ProcessCodeBidder = (filters) => ({
    type: PROCESS_CODE_BIDDER,
    payload: { filters: filters }
});

export const ProcessCodeBidderSuccess = (data) => ({
    type: PROCESS_CODE_BIDDER_SUCCESS,
    payload: data
});

export const ProcessCodeBidderError = (error) => ({
    type: PROCESS_CODE_BIDDER_ERROR,
    payload: error
});

export const ProccessYearBidder = (filters) => ({
    type: PROCCESS_YEAR_BIDDER,
    payload: { filters: filters }
});

export const ProccessYearBidderSuccess = (data) => ({
    type: PROCCESS_YEAR_BIDDER_SUCCESS,
    payload: data
});

export const ProccessYearBidderError = (error) => ({
    type: PROCCESS_YEAR_BIDDER_ERROR,
    payload: error
});

export const LoteState = (filters) => ({
    type: LOTE_STATE,
    payload: { filters: filters }
});

export const LoteStateSuccess = (data) => ({
    type: LOTE_STATE_SUCCESS,
    payload: data
});

export const LoteStateError = (error) => ({
    type: LOTE_STATE_ERROR,
    payload: error
});

export const YearDemand = (filters) => ({
    type: YEAR_DEMAND,
    payload: { filters: filters }
});

export const YearDemandSuccess = (data) => ({
    type: YEAR_DEMAND_SUCCESS,
    payload: data
});

export const YearDemandError = (error) => ({
    type: YEAR_DEMAND_ERROR,
    payload: error
});

export const YearGob360 = (filters) => ({
    type: YEAR_GOB360,
    payload: { filters: filters }
});

export const YearGob360Success = (data) => ({
    type: YEAR_GOB360_SUCCESS,
    payload: data
});

export const YearGob360Error = (error) => ({
    type: YEAR_GOB360_ERROR,
    payload: error
});

export const InstitutionGob360 = (filters) => ({
    type: INSTITUTION_GOB360,
    payload: { filters: filters }
});

export const InstitutionGob360Success = (data) => ({
    type: INSTITUTION_GOB360_SUCCESS,
    payload: data
});

export const InstitutionGob360Error = (error) => ({
    type: INSTITUTION_GOB360_ERROR,
    payload: error
});


export const ProcessCodeOpening = (filters) => ({
    type: PROCESS_CODE_OPENING,
    payload: { filters: filters }
});

export const ProcessCodeOpeningSuccess = (data) => ({
    type: PROCESS_CODE_OPENING_SUCCESS,
    payload: data
});

export const ProcessCodeOpeningError = (error) => ({
    type: PROCESS_CODE_OPENING_ERROR,
    payload: error
});

export const UnitPrice = (filters) => ({
    type: UNIT_PRICE,
    payload: { filters: filters }
});

export const UnitPriceSuccess = (data) => ({
    type: UNIT_PRICE_SUCCESS,
    payload: data
});

export const UnitPriceError = (error) => ({
    type: UNIT_PRICE_ERROR,
    payload: error
});

export const UnitPriceTransacciones = (filters) => ({
    type: UNIT_PRICE_TRANSACCIONES,
    payload: { filters: filters }
});

export const UnitPriceTransaccionesSuccess = (data) => ({
    type: UNIT_PRICE_TRANSACCIONES_SUCCESS,
    payload: data
});

export const UnitPriceTransaccionesError = (error) => ({
    type: UNIT_PRICE_TRANSACCIONES_ERROR,
    payload: error
});

export const ListArticleOrpCode22 = (filters) => ({
    type: LIST_ARTICLE_ORP_CODE22,
    payload: { filters: filters }
});

export const ListArticleOrpCode22Success = (data) => ({
    type: LIST_ARTICLE_ORP_CODE22_SUCCESS,
    payload: data
});

export const ListArticleOrpCode22Error = (error) => ({
    type: LIST_ARTICLE_ORP_CODE22_ERROR,
    payload: error
});

export const ListArticleCodeCountry = (filters) => ({
    type: LIST_ARTICLE_CODE_COUNTRY,
    payload: { filters: filters }
});

export const ListArticleCodeCountrySuccess = (data) => ({
    type: LIST_ARTICLE_CODE_COUNTRY_SUCCESS,
    payload: data
});

export const ListArticleCodeCountryError = (error) => ({
    type:  LIST_ARTICLE_CODE_COUNTRY_ERROR,
    payload: error
});

export const ListArticleCodeCountryBidder = (filters) => ({
    type: LIST_ARTICLE_CODE_COUNTRY_BIDDER,
    payload: { filters: filters }
});

export const ListArticleCodeCountryBidderSuccess = (data) => ({
    type: LIST_ARTICLE_CODE_COUNTRY_BIDDER_SUCCESS,
    payload: data
});

export const ListArticleCodeCountryBidderError = (error) => ({
    type: LIST_ARTICLE_CODE_COUNTRY_BIDDER_ERROR,
    payload: error
});

export const CountryTabAward = (filters, stateFilter) => ({
    type: COUNTRY_TAB_AWARD,
    payload: { filters: filters, filtersState: stateFilter }
});

export const CountryTabAwardSuccess = (data) => ({
    type: COUNTRY_TAB_AWARD_SUCCESS,
    payload: data
});

export const CountryTabAwardError = (error) => ({
    type: COUNTRY_TAB_AWARD_ERROR,
    payload: error
});

export const ProccessCodeTabAward = (filters, stateFilter) => ({
    type: PROCCESS_CODE_TAB_AWARD,
    payload: { filters: filters, filtersState: stateFilter }
});

export const ProccessCodeTabAwardSuccess = (data) => ({
    type: PROCCESS_CODE_TAB_AWARD_SUCCESS,
    payload: data
});

export const ProccessCodeTabAwardError = (error) => ({
    type: PROCCESS_CODE_TAB_AWARD_ERROR,
    payload: error
});

export const YearTabAward = (filters, stateFilter) => ({
    type: YEAR_TAB_AWARD,
    payload: { filters: filters, filtersState: stateFilter }
});

export const YearTabAwardSuccess = (data) => ({
    type: YEAR_TAB_AWARD_SUCCESS,
    payload: data
});

export const YearTabAwardError = (error) => ({
    type: YEAR_TAB_AWARD_ERROR,
    payload: error
});

export const ProccessCodeTabOpenning = (filters, stateFilter) => ({
    type: PROCCESS_CODE_TAB_OPENNING,
    payload: { filters: filters, filtersState: stateFilter }
});

export const ProccessCodeTabOpenningSuccess = (data) => ({
    type: PROCCESS_CODE_TAB_OPENNING_SUCCESS,
    payload: data
});

export const ProccessCodeTabOpenningError = (error) => ({
    type: PROCCESS_CODE_TAB_OPENNING_ERROR,
    payload: error
});

export const YearTabOpenning = (filters, stateFilter) => ({
    type: YEAR_TAB_OPENNING,
    payload: { filters: filters, filtersState: stateFilter }
});

export const YearTabOpenningSuccess = (data) => ({
    type: YEAR_TAB_OPENNING_SUCCESS,
    payload: data
});

export const YearTabOpenningError = (error) => ({
    type: YEAR_TAB_OPENNING_ERROR,
    payload: error
});

export const CountryTabOpenning = (filters, stateFilter) => ({
    type: COUNTRY_TAB_OPENNING,
    payload: { filters: filters, filtersState: stateFilter }
});

export const CountryTabOpenningSuccess = (data) => ({
    type: COUNTRY_TAB_OPENNING_SUCCESS,
    payload: data
});

export const CountryTabOpenningError = (error) => ({
    type: COUNTRY_TAB_OPENNING_ERROR,
    payload: error
});

export const ArticleCode22Supplier = (filters, stateFilter) => ({
    type: ARTICLE_CODE22_SUPPLIER,
    payload: { filters: filters, filtersState: stateFilter }
});

export const ArticleCode22SupplierSuccess = (data) => ({
    type: ARTICLE_CODE22_SUPPLIER_SUCCESS,
    payload: data
});

export const ArticleCode22SupplierError = (error) => ({
    type: ARTICLE_CODE22_SUPPLIER_ERROR,
    payload: error
});

export const ArticleCodeCountrySupplier = (filters, stateFilter) => ({
    type: ARTICLE_CODE_COUNTRY_SUPPLIER,
    payload: { filters: filters, filtersState: stateFilter }
});

export const ArticleCodeCountrySupplierSuccess = (data) => ({
    type: ARTICLE_CODE_COUNTRY_SUPPLIER_SUCCESS,
    payload: data
});

export const ArticleCodeCountrySupplierError = (error) => ({
    type: ARTICLE_CODE_COUNTRY_SUPPLIER_ERROR,
    payload: error
});

export const CountrySupplierInfo = (filters, stateFilter) => ({
    type: COUNTRY_SUPPLIER_INFO,
    payload: { filters: filters, filtersState: stateFilter }
});

export const CountrySupplierInfoSuccess = (data) => ({
    type: COUNTRY_SUPPLIER_INFO_SUCCESS,
    payload: data
});

export const CountrySupplierInfoError = (error) => ({
    type: COUNTRY_SUPPLIER_INFO_ERROR,
    payload: error
});

export const SupplierInfo = (filters, stateFilter) => ({
    type: SUPPLIER_INFO,
    payload: { filters: filters, filtersState: stateFilter }
});

export const SupplierInfoSuccess = (data) => ({
    type: SUPPLIER_INFO_SUCCESS,
    payload: data
});

export const SupplierInfoError = (error) => ({
    type: SUPPLIER_INFO_ERROR,
    payload: error
});

export const MedDescriptionRazonabilidad = (filters, stateFilter) => ({
    type: MED_DESCRIPTION_RAZONABILIDAD,
    payload: { filters: filters, filtersState: stateFilter }
});

export const MedDescriptionRazonabilidadSuccess = (data) => ({
    type: MED_DESCRIPTION_RAZONABILIDAD_SUCCESS,
    payload: data
});

export const MedDescriptionRazonabilidadError = (error) => ({
    type: MED_DESCRIPTION_RAZONABILIDAD_ERROR,
    payload: error
});

export const ListArticleRazonabilidad = (filters, stateFilter) => ({
    type: LIST_ARTICLE_RAZONABILIDAD,
    payload: { filters: filters, filtersState: stateFilter }
});

export const ListArticleRazonabilidadSuccess = (data) => ({
    type: LIST_ARTICLE_RAZONABILIDAD_SUCCESS,
    payload: data
});

export const ListArticleRazonabilidadError = (error) => ({
    type: LIST_ARTICLE_RAZONABILIDAD_ERROR,
    payload: error
});

export const CountryAward = (filters, stateFilter) => ({
    type: COUNTRY_AWARD,
    payload: { filters: filters, filtersState: stateFilter }
});

export const CountryAwardSuccess = (data) => ({
    type: COUNTRY_AWARD_SUCCESS,
    payload: data
});

export const CountryAwardError = (error) => ({
    type: COUNTRY_AWARD_ERROR,
    payload: error
});

export const Role = (filters, stateFilter) => ({
    type: ROLE,
    payload: { filters: filters, filtersState: stateFilter }
});

export const RoleSuccess = (data) => ({
    type: ROLE_SUCCESS,
    payload: data
});

export const RoleError = (error) => ({
    type: ROLE_ERROR,
    payload: error
});

export const RoleOrp = (filters, stateFilter) => ({
    type: ROLE_ORP,
    payload: { filters: filters, filtersState: stateFilter }
});

export const RoleOrpSuccess = (data) => ({
    type: ROLE_ORP_SUCCESS,
    payload: data
});

export const RoleOrpError = (error) => ({
    type: ROLE_ORP_ERROR,
    payload: error
});

const catalogList = (state) => state[NAME];

export const CatalogListSelector = createStructuredSelector({
  catalogList
})
